/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../../Modal';
import Form from '../../Form';
import useForm from '../../../hooks/useForm';
import { isEmpty } from '../../../utils/lodashExtend';
import { BILLING_STATUS, MANAGEMENT_PAYMENT_TYPE, PAYMENT_TYPE, PAYPERIODIC_CYCLE_UNIT } from '../../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE';
import TabList from '../../Tab';
import Button from '../../Button';
import TaxProdListModal from '../TaxProd/TaxProdListModal';
import { dateToFormat, getDay } from '../../../utils/date';
import { addBilling, editBilling } from '../../../apis/tax-portal/billing';
import { toast } from '../../../utils/toast';
import Payments from './Payments';
import { isNumber } from '../../../utils/validator';
import { restoreComma } from '../../../utils/validator/comma';
import { shallowEqual, useSelector } from 'react-redux';



/**
 * @description
 * 계약상품 불러오기는 등록에만 가능
 * 
 * payStartDate 가 벗어난 계약데이터 수정가능
 * 1. 계약명
 * 2. 메모
 * 3. 계약상태
 */

const Contract = (props) => {
  const {
    taxpayerList,
  } = useSelector(
    (store) => ({
      taxpayerList: store.Data.taxpayerList,

    }),
    shallowEqual
  );
  const { open, setOpen, submit, selectedItem, setSelectedItem, taxpayer } = props;
  const [mode, setMode] = useState("create");
  const [activeTab, setActiveTab] = useState("billing");
  const [isStarted, setIsStarted] = useState(false);

  const [managementList, setManagementList] = useState([]);
  const [taxProdOen, setTaxProdOpen] = useState(false);
  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);

    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
    setActiveTab("billing");
    setManagementList([]);
    resetForm(defaultForm);
  };

  const defaultForm = {
    postIdx: taxpayer?.idx,
    postType: "management",
    paymentType: PAYMENT_TYPE[0].value,
    price: "0",
    type: "periodic",
    payStartDate: [`${getDay()}`],
    paySingleDate: [`${getDay()}`],
    payPeriodicCycleUnit: "month",
    payPeriodicDate: 1,
    title: "",
    status: BILLING_STATUS[0].value,
    memo: "",
    companyName: taxpayer?.companyName,
    ceoName: taxpayer?.ceoName,

  };

  const [fields, setFields] = useState([]);

  const _submit = (form) => {
    form = {
      ...form,
      ...(!isEmpty(form.payStartDate) && {
        payStartDate: form.payStartDate[0],
      }),
      ...(!isEmpty(form.paySingleDate) && {
        paySingleDate: form.paySingleDate[0],
      }),
      form: isNumber(form.price) ? form.price : 0,
    };

    if (mode === "create") {
      addBilling(form).then(res => {
        toast.success('등록이 완료되었습니다.');
        cancel();
      }).catch(e => console.error(e));
    } else {
      const body = isStarted ? {
        title: form.title,
        memo: form.memo,
        status: form.status,
        fileIdxes: form.fileIdxes,
      } : form;

      editBilling(selectedItem.idx, body)
        .then(res => {
          toast.success('변경이 완료되었습니다.');
          cancel();
        })
        .catch(e => console.error(e));
    }
  };

  useEffect(() => {
    setManagementList(taxpayerList.map(item => {
      return {
        label: `${item.companyName}(${item.ceoName || ""})`,
        value: item.idx + "",
        ...item
      };
    }));

  }, [taxpayerList]);

  useEffect(() => {
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      const today = dateToFormat();
      const isStarted = new Date(today) >= new Date(selectedItem.payStartDate);
      setIsStarted(isStarted);
      setForm({
        ...selectedItem,
        payStartDate: [selectedItem.payStartDate],
        ceoName: selectedItem.management?.ceoName,
        companyName: selectedItem.management?.companyName,
        fileIdxes: selectedItem.uploadFiles || [],
      });
      setOriginForm({
        ...selectedItem,
        payStartDate: [selectedItem.payStartDate],
        ceoName: selectedItem.management?.ceoName,
        companyName: selectedItem.management?.companyName,
        fileIdxes: selectedItem.uploadFiles || [],
      });
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
      setIsStarted(false);
    }

  }, [open, selectedItem]);

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
    resetForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {

    if (!isEmpty(managementList) && isEmpty(taxpayer)) {
      setForm({ postIdx: managementList[0].value });
    }
  }, [managementList, isStarted, open, mode]);

  useEffect(() => {
    const supplyAmt = +restoreComma(form?.supplyAmt);
    const taxAmt = Math.max(Math.floor(supplyAmt * 0.1), 0) + "";
    if (supplyAmt > 0) {
      setForm({
        taxAmt,
      });
    }
  }, [form && form.supplyAmt]);

  useEffect(() => {
    const supplyAmt = +restoreComma(form?.supplyAmt);
    const taxAmt = +restoreComma(form.taxAmt);
    if (taxAmt > 0) {
      setForm({
        totalAmt: supplyAmt + taxAmt
      });
    }
  }, [form && form.taxAmt]);

  useEffect(() => {
    const totalAmt = +restoreComma(form?.totalAmt);
    if (totalAmt > 0) {
      const supplyAmt = Math.ceil(totalAmt / 1.1);
      const taxAmt = totalAmt - supplyAmt;
      setForm({
        supplyAmt,
        taxAmt
      });
    }
  }, [form && form.totalAmt]);

  useEffect(() => {
    const _fields = [
      [
        {
          title: "계약명",
          key: "title",
          type: "input",
          required: true,
          placeholder: "ex) 기장대리계약서"
        }
      ],
      [
        {
          title: "수임처 선택",
          key: "postIdx",
          type: "search-select",
          isHide: isStarted || !isEmpty(taxpayer),
          options: {
            list: managementList
          },
          disabled: isStarted,
          zIndex: 100,
          isControlShouldRenderValue: true,
          placeholder: "상호명 또는 대표명 검색",
          onChange: (data) => {
            setForm({
              postIdx: data.value,
              companyName: data.companyName,
              ceoName: data.ceoName,
            });
          },
        },
      ],
      [
        {
          title: "상호명",
          key: "companyName",
          type: "input",
          disabled: true,
        },
        {
          title: "대표명",
          key: "ceoName",
          type: "input",
          disabled: true,
        },
      ],
      [
        {
          title: "계약 상태",
          key: "status",
          type: "select",
          options: {
            list: BILLING_STATUS
          },
        }
      ],
      [
        {
          title: "공급가액",
          disabled: isStarted,
          key: "supplyAmt",
          type: "input",
          validators: ['comma'],
        },
        {
          title: "부가세",
          disabled: isStarted,
          key: "taxAmt",
          type: "input",
          validators: ['comma'],
        },
      ],
      [
        {
          title: "합계금액",
          disabled: isStarted,
          key: "totalAmt",
          type: "input",
          validators: ['comma'],
        },
        {
          title: "납부방식",
          disabled: isStarted,
          key: "paymentType",
          type: "select",
          options: {
            list: PAYMENT_TYPE
          },
        },

      ],
      [
        {
          title: "청구 시작일",
          disabled: isStarted,
          type: "datepicker",
          key: "payStartDate",
          required: true,
        },
        {
          title: "청구 유형",
          disabled: isStarted,
          key: "type",
          type: "select",
          // className: "margin-right-16",
          options: {
            list: MANAGEMENT_PAYMENT_TYPE.slice(1),
          },
          required: true,
        },
      ],
      [
        {
          title: "개별 청구일",
          isHide: ({ form }) => form?.type === "periodic",
          disabled: isStarted,
          type: "datepicker",
          key: "paySingleDate",
        },
      ],
      [
        {
          title: "주기타입",
          isHide: ({ form }) => form?.type === "single",
          disabled: isStarted,
          key: "payPeriodicCycleUnit",
          type: "select",
          options: { list: PAYPERIODIC_CYCLE_UNIT }
        },
        {
          title: "정기청구 주기",
          isHide: ({ form }) => form?.type === "single",
          disabled: isStarted,
          key: "payPeriodicDate",
          type: "number",
        }
      ],
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
          required: false,
        },
      ],
      [
        {
          title: "메모",
          key: "memo",
          type: "textarea"
        }
      ],
    ];
    setFields(_fields);
  }, [open, mode, form]);

  const _setActiveTab = (value) => {
    setActiveTab(value);
  };

  const tabList = [
    {
      label: "계약 관리",
      action: _setActiveTab,
      value: "billing",
    },
    {
      label: "결제 관리",
      action: _setActiveTab,
      value: "payment",
    },
  ];

  const taxProdSubmit = (data) => {
    const { title = "", memo = "", taxAmt, supplyAmt, totalAmt } = data;
    setForm({
      title, memo, taxAmt, supplyAmt, totalAmt
    });
  };

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
        className="taxPortal-billing-detail"
      >
        <ModalHeader>
          {`계약 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>

        {mode !== "create" && (
          <TabList
            tabList={tabList}
            active={activeTab}
          />
        )}
        {mode === "create" && (
          <div className="header-button-wrap">
            <Button
              className="print-button print-out"
              label="세무상품 불러오기"
              onClick={() => setTaxProdOpen(true)}
            />
          </div>
        )}
        {activeTab === "billing" && (mode === "create" || selectedItem) && (
          <Form
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            submitText={mode === "create" ? "등록" : "수정"}
            submit={handleSubmit}
            cancel={cancel}
          />
        )}

        {activeTab === "payment" && !isEmpty(selectedItem) && (
          <Payments {...selectedItem} />
        )}
      </Modal>

      <TaxProdListModal
        open={taxProdOen}
        setOpen={setTaxProdOpen}
        submit={taxProdSubmit}
      />
    </>
  );
};

export default Contract;